import { openDialogCreateCommand } from './open_dialog_create';

export const openDialogCommands = [
  openDialogCreateCommand
];

export { openDialogCreateCommand };

